<template>
    <div>
        <el-dropdown trigger="click" placement="bottom">
            <span class="el-dropdown-link">
                <!-- <el-tooltip class="item" effect="dark" content="Products" placement="bottom"> -->
                    <div class="mr-0 mt-2 pointer row align-items-center justify-content-center no-gutters text-white box-shadow">
                        <!-- <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/products.svg" width="30"> -->
                        <img class="avatar"  width="25" :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" />
                    </div>
                <!-- </el-tooltip> -->
            </span>
            <el-dropdown-menu slot="dropdown" v-if="!switch_success">
                <div class="user-menu-button" >
                    <div class="position-relative">
                        <!-- <span class="pointer" @click="showHideCompSwitchDropdown">
                            <div class="d-flex align-items-center" style="height: 35px; border-radius: 5px;">
                                <div class="avatar-wrapper">
                                    <img class="avatar"
                                        :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" />
                                </div>
                            </div>
                        </span>
                        <div v-if="show_hide_comp_switch_dropdown" @click="onBlurHideCompSwitch" class="switch-company-backdrop">
                        </div> -->
                        <div class="admin-width">
                            <!-- <div v-if="user_company.organization_name">
                                <div style="text-align: center;" class="my-3">
                                    <span class="fs-12 fw-600"> This account is managed by <span class="text-capitalize">{{user_company.organization_name}}</span></span>
                                </div>
                            </div> -->
                            <div class="dropdown-width-responsive" style="background-color: #f4f4f4 !important;">
                                <div class="pt-3">
                                    <div class="d-flex align-items-center w-100 pt-2 pb-0">
                                        <!-- <div class="ml-4"> -->
                                            <div>
                                                <span class="fs-14 fw-600 pl-6" style="color: #61696c;"> Your Account</span>
                                            </div>
                                            <div class="col-1 hide-on-mob-screen">
                                                <div class="settings-icon pointer setting-align" @click="goToSettings">
                                                    <img width="22" src="/static/images/settings-3-line.svg" />
                                                </div>
                                            </div>
                                        <!-- </div> -->
                                    </div>
                                    <div class="d-flex align-items-center w-100 pt-2 pb-0">
                                        <div class="switch-user-prpfile ml-4">
                                            <img style="border-radius: 50%;" :src="loggedInUser.profile_pic || 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'" width="50" height="50" />
                                            <div class="col-1 hide-on-mob-screen">
                                                <!-- <div class="pointer btn-size">
                                                    <button class="btn btn-secondary btn-smm" :disabled="load_logout" @click="logout()">
                                                        Logout
                                                        <half-circle-spinner v-if="load_logout" :animation-duration="1000" :size="25" color="#00448b" style="margin: 0px auto;padding-top:30px;position:absolute;bottom:32px;right:25px" />
                                                    </button>
                                                </div> -->
                                                <!-- <div class="settings-icon pointer setting-align" @click="goToSettings">
                                                    <img width="18" src="https://testcrm.digicollect.com/static/images/images-new-theme/icons/settings-new-right.svg"/>
                                                </div> -->
                                            </div>
                                        </div>
                                        <div class="w-100 pl-2 pt-3">
                                            <div class="text-secondary fs-14 pl-2 pr-4">
                                                <span class="fw-800 text-capitalize" style="color: #2d3436;"
                                                    :title="loggedInUser.full_name">{{loggedInUser.full_name}}</span>
                                                <span class="ml-1 text-gray fw-600 text-capitalize" style="color: #3f3f3f;">({{loggedInUser.user_role.replaceAll('_',' ')}})</span>
                                            </div>
                                            <div class="d-flex main-dropdown justify-content-between pointer pl-2 pr-4 background-default">
                                                <div class="mt-1">
                                                    <!-- <h1 class="fs-14 fw-500 mb-0 text-capitalize" style="color: #6c7071;">{{user_company.organization_name}}</h1> -->
                                                    <!-- <h1 class="fs-14 fw-500 mb-0 text-capitalize" style="color: #6c7071;">{{loggedInUser.user_role.replaceAll('_',' ')}}</h1> -->
                                                    <h1 v-if="user_company.company_name" class="fs-14 text-gray mb-0 text-secondary text-capitalize">{{user_company.company_name || "-"}} <span class="text-secondary" >(Selected)</span></h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="show-on-mob-screen text-right mx-3">
                                    <button class="btn btn-secondary btn-smm" @click="logout()" :disabled="load_logout">
                                        Logout
                                        <half-circle-spinner v-if="load_logout" :animation-duration="1000" :size="25" color="#00448b" style="margin: 0px auto;padding-top:30px;position:absolute;bottom:32px;right:7px" />
                                    </button>
                                </div> -->
                                <hr class="mt-2 mx-3">
                                <div v-if="org_company_list_loading">
                                    <half-circle-spinner :animation-duration="1000" :size="30" color="#00448b" style="margin: 0 auto;" />
                                </div>
                                <template v-else>
                                    <div class="mt-3" v-if="loggedInUser.user_has == 'organization'">
                                        <span class="fs-14 fw-600 pl-6" style="color: #61696c;"> Your organizations</span>
                                    </div>
                                    <div @scroll="scrollGetOrganizationAndComp" v-if="comp_data.length > 0" :class="{'overflow-height':comp_data.length > 0}">
                                        <div v-for="(comp, comp_index) in comp_data" :key="comp_index" class="mt-1">
                                            <!-- <hr class="mt-5"> -->
                                        <template v-if="loggedInUser.user_has == 'organization'">
                                            <div v-if="comp.company_list">
                                                <div class="d-flex align-items-center w-100 py-2">
                                                    <div class="w-100 pl-6 pr-2">
                                                        <div class="d-flex align-items-center main-dropdown subcompany-dropdown justify-content-between pointer pl-2 pr-4" :class="{'green-active-org':comp_index == 0,'br-t-r-5':comp.org_active, 'border-hide':comp.org_active}" @click="compActive(comp_index)">
                                                            <div class="d-flex align-items-center">
                                                                <avatar
                                                                    class="navbar-avatar navbar-avatar-org-name"
                                                                    :username="comp.organization_name.replace(/ .*/,'')"
                                                                    :src="''"
                                                                    :size="40"
                                                                    :rounded="false"
                                                                    :color="comp_index == 0 ? '#ffffff' : '#ffffff'"
                                                                    :background-color="comp_index == 0 ? '#707070' : '#707070'">
                                                                    <!-- :color="comp_index == 0 ? '#008b29' : '#ffffff'" -->
                                                                </avatar>
                                                                <div class="mt-0 ml-3">
                                                                    <!-- :class="{'text-white':comp_index == 0, 'text-gray':comp_index != 0}" -->
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500">{{comp.organization_name}}</h1>
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" v-if="comp_index == 0 && !comp.org_active" style="color: #00448b;" :class="{'text-success':comp.selected, 'not-selected':!comp.selected}">{{user_company.company_name}}</h1>
                                                                </div>
                                                            </div>
                                                            <div v-if="comp.company_list.length > 0" class="mob-left-padding-drop">
                                                                <i style="font-size: 25px;" class="icon el-icon-arrow-up fw-700 org-icon-rotate-transition" :class="{'org-icon-rotate-down':!comp.org_active,'dc-text-black':comp_index == 0, 'dc-text-black':comp_index != 0}"></i>
                                                                <!-- <i style="font-size: 25px;" v-else class="icon el-icon-arrow-down fw-700" :class="{'text-white':comp_index == 0, 'dc-text-black':comp_index != 0}"></i> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="comp.org_active" class="ml-6 mr-2"  style="box-shadow: 0 0 6px 0 rgba(178, 191, 235, 0.87);">
                                                    <hr class="mx-2" style="border-top: 1px solid #606060 !important;">
                                                    <div v-for="(company, company_index) in comp.company_list" :key="company_index" class="d-flex align-items-center w-100 company-list list-dropdown" v-show="!company.selected" :class="{'color-active': comp_index == 0}">
                                                        <div class="mr-2">
                                                            <input type="radio" :class="{'pointer-events-none': !company.can_company_switch, 'pointer':company.can_company_switch}" v-if="user_company.company_name == company.company_name" :value="company.company_name" name="company.company_name" v-model="company.company_name"/>
                                                            <input type="radio" :class="{'pointer-events-none': !company.can_company_switch, 'pointer':company.can_company_switch}" v-else v-on:click="switchNewCompany(company.company_id, company.can_company_switch)" :value="company.company_name" name="company.company_name"/>
                                                            
                                                        </div>
                                                        <div v-if="company.logo" class="pl-2" :class="{'back-color':company.selected}" style="border-top-left-radius: 2px;border-bottom-left-radius: 2px">
                                                            <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="company.logo" width="20" height="20" />
                                                        </div>
                                                        <div v-else  :class="{'back-color':company.selected}" style="border-top-left-radius: 2px;border-bottom-left-radius: 2px">
                                                            <avatar
                                                                class="navbar-avatar navbar-avatar-comp-name"
                                                                :username="company.company_name.replace(/ .*/,'')"
                                                                :src="''"
                                                                :size="30"
                                                                :rounded="false"
                                                                :color="company.selected ? '#ffffff' : '#ffffff'"
                                                                :background-color="company.selected ? '#008b29' : '#707070'">
                                                            </avatar>
                                                        </div>
                                                        <div class="w-100 pl-2"  :class="{'back-color':company.selected}" style="border-top-right-radius: 2px;border-bottom-right-radius: 2px">
                                                            <div class="d-flex align-items-center justify-content-between">
                                                                <div>
                                                                    <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':company.selected, 'not-selected':!company.selected}">{{company.company_name}}</h1>
                                                                </div>
                                                                <!-- <div v-if="!company.selected" :class="{'cursor-not-allowed': !company.can_company_switch}">
                                                                    <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !company.can_company_switch}" @click="switchNewCompany(company.company_id, company.can_company_switch)">Switch</h1>
                                                                </div> -->
                                                                <!-- <div v-else class="pr-3">
                                                                    <i class="icon icon-check-circle text-success"></i>
                                                                </div> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="d-flex align-items-center w-100 company-list list-dropdown" style="background-color: #fff;height: 48px !important;">
                                                <div v-if="comp.logo" :class="{'back-color':comp.selected}" style="border-top-left-radius: 2px;border-bottom-left-radius: 2px">
                                                    <img style="border-radius: 50%; border: 2px solid #ecf1f9;" :src="comp.logo" width="20" height="20" />
                                                </div>
                                                <div v-else style="border-top-left-radius: 2px;border-bottom-left-radius: 2px">
                                                    <avatar
                                                        class="navbar-avatar navbar-avatar-comp-name"
                                                        :username="comp.company_name.replace(/ .*/,'')"
                                                        :src="''"
                                                        :size="30"
                                                        :rounded="false"
                                                        :color="comp.selected ? '#ffffff' : '#ffffff'"
                                                        :background-color="comp.selected ? '#008b29' : '#707070'">
                                                    </avatar>
                                                </div>
                                                <div class="w-100 pl-2" :class="{'back-color':comp.selected}" style="border-top-right-radius: 2px;border-bottom-right-radius: 2px">
                                                    <div class="d-flex align-items-center justify-content-between">
                                                        <div>
                                                            <h1 class="fs-14 mb-0 text-capitalize fw-500" :class="{'text-success':comp.selected, 'not-selected':!comp.selected}">{{comp.company_name}}</h1>
                                                        </div>
                                                        <div v-if="!comp.selected" :class="{'cursor-not-allowed': !comp.can_company_switch}">
                                                            <h1 class="fs-14 text-secondary mb-0 pointer fw-500" :class="{'pointer-events-none': !comp.can_company_switch}" @click="switchNewCompany(comp.company_id, comp.can_company_switch)">Switch</h1>
                                                        </div>
                                                        <div v-else class="pr-3">
                                                            <i class="icon icon-check-circle text-success"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <hr class="mt-2 mx-3">
                                <div style="text-align: center !important;" class="">
                                    <!-- <a class="fs-14 fw-600 pointer" href="javascript:void(0)" style="color: #130e0e !important;" @click="logout"> Sign Out</a> -->
                                    <button type="button" class="btn btn-link p-o m-0 fw-600 fs-14" style="color: #130e0e !important;text-transform: none;" @click="logout">Sign Out</button>
                                </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dropdown-menu>
        </el-dropdown>
        <!-- <div class="mt-3 justify-content-center animated" style="display: flex; z-index: 99999 !important;" :class="{'in-down':switch_success == false || switch_success,'d-none':!switch_success,'fadeOut': switch_success == false}" v-if="switch_success">
            <switch-company-success @hideSuccess="hideSuccess" :success_message="switch_comp_success_message" modal_name="switch-success" style="z-index:9999 !important"></switch-company-success>
        </div> -->
    </div>
</template>
<script>
import global from '../global';
import axios from 'axios'
import { EventBus } from '../eventBus/nav-bar-event.js'
import navbarMixin from '../mixins/navbarMixin.js';
import notification from '../mixins/notification.js';
import crm from "../mixins/crm.js"
import { SweetModal } from 'sweet-modal-vue';
const SwitchCompanySuccess = () => import('./SwitchCompanySuccess');
import { HalfCircleSpinner } from 'epic-spinners'
import moment from 'moment-timezone';
import Avatar from 'vue-avatar';
export default {
    components: {
        Avatar,
        SweetModal,
        HalfCircleSpinner,
        SwitchCompanySuccess
    },
    mixins: [navbarMixin, notification, crm],
    data(){
        return{
            success_msg: '',
            warning_msg: '',
            allProduct:[],
            purchased_product:[],
            search_key:'',
            filter_purchased_product:[],
            filter_allProduct:[],
            value:false,
            api_call_in_progress:false,
            new_token: "",
            comp_active: false,
            switch_success: false,
            switch_comp_success_message: '',
            show_hide_comp_switch_dropdown: false,
            user_company: [],
            count_org_comp: 0,
            org_company_list_flag: false,
            org_company_list_loading: false,
            skip: 0,
            comp_data: [],
            comp_limit: 10,
            scroll_flag: false,
            load_logout: false,
        }
    },
    methods:{
        compActive(index) {
            this.comp_data[index].org_active = !this.comp_data[index].org_active
            this.$forceUpdate();
        },
        goToSettings() {
            this.show_hide_comp_switch_dropdown = false
            if(location.origin.startsWith('http://localhost') || location.origin.startsWith('https://testhelpdesk.digicollect.com')){
                window.open('https://testadmin.digicollect.com/','_blank');
            }else if(location.origin.startsWith('https://helpdesk.digicollect.com')){
                window.open('https://admin.digicollect.com/','_blank');
            }
            // this.$router.push('/settings');
        },
        async logout() {
            try {
                this.load_logout = true
                EventBus.$emit('UnSubscribe')
                await axios.get(global.AUTH_SERVICE + '/auth/logout').then((resp)=>{
                    console.log(resp)
                    if(resp.data.status_id == 1) {
                        localStorage.clear();
                        this.$cookie.delete("Token");
                        this.$cookie.delete('Token', {
                            domain: 'digicollect.com'
                        });
                        window.location.href = global.HELP_URL;
                        this.load_logout = false
                    }
                }).catch((err)=>{
                    this.load_logout = false
                    this.$cookie.delete("Token");
                    this.$cookie.delete('Token', {
                        domain: 'digicollect.com'
                    });
                    window.location.href = global.HELP_URL;
                })
            } catch (error) {
                console.error('Logout failed:', error);
            }
        },
        showHideCompSwitchDropdown() {
            this.show_hide_comp_switch_dropdown = !this.show_hide_comp_switch_dropdown;
            if(this.org_company_list_flag == false) {
                this.getOrganizationAndComp();
            }
        },
        async getOrganizationAndComp() {
            try {
                this.org_company_list_loading = true;
                let param = {
                    skip: this.skip,
                    limit: this.comp_limit,
                    search_key: this.search_key,
                    is_company_switcher: true,
                    product: "DigiHelp"
                };
                let response = await this.getHierarchyListView(param);
                if(response.status_id == 1) {
                    this.comp_data = response.response;
                    this.user_company = response.user_company;
                    if(this.loggedInUser.user_has == 'organization') {
                        this.comp_data.forEach((element, index) => {
                            element['org_active'] = false
                            element.company_list.forEach((element1, index1) => {
                                if(element1.selected) {
                                    this.outer_el = index;
                                    this.inner_el = index1;
                                }
                                return;
                            });
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        var element1 = element.company_list[this.inner_el];
                        element.company_list.splice(this.inner_el, 1);
                        element.company_list.splice(0, 0, element1);
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    } else if(this.loggedInUser.user_has == 'company') {
                        this.comp_data.forEach((element, index) => {
                            if(element.selected) {
                                this.outer_el = index;
                            }
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    }
                    this.count_org_comp = response.response.length;
                    this.org_company_list_flag = true;
                    this.org_company_list_loading = false;
                    this.$store.commit('setCompanyDetails', response.user_company);
                }
            }
            catch(err) {
                console.log(err);
                this.org_company_list_flag = false;
                this.org_company_list_loading = false;
            }
        },
        async scrollGetOrganizationAndComp(e) {
			if(this.scroll_flag == false) {
                const {target} = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    // set scroll_flag true immediately so rapid/duplicate scroll events don't
                    // fire the same request again before this one resolves (was causing duplicate entries)
                    this.scroll_flag = true;
                    try {
                        let param = {
                            skip: this.count_org_comp,
                            limit: this.comp_limit,
                            search_key: this.search_key,
                            is_company_switcher: true,
                            product: "DigiHelp"
                        };
                        let response = await this.getHierarchyListView(param);
                        if(response.status_id == 1) {
                            if (response.skip == this.count_org_comp) {
                                let tempFiles = response.response
                                // the API re-includes the currently selected org/company (pinned to the top)
                                // on every page, so pushing tempFiles as-is re-adds it on each scroll load.
                                // Filter out anything whose company_id we've already loaded before pushing.
                                if(this.loggedInUser.user_has == 'organization') {
                                    let existingCompanyIds = new Set(
                                        this.comp_data.flatMap(o => (o.company_list || []).map(c => c.company_id))
                                    );
                                    tempFiles = tempFiles.filter(el =>
                                        !(el.company_list || []).some(c => existingCompanyIds.has(c.company_id))
                                    );
                                } else if(this.loggedInUser.user_has == 'company') {
                                    let existingCompanyIds = new Set(this.comp_data.map(c => c.company_id));
                                    tempFiles = tempFiles.filter(el => !existingCompanyIds.has(el.company_id));
                                }
                                tempFiles.forEach(el => {
                                    this.comp_data.push(el)
                                })
                                if(this.loggedInUser.user_has == 'organization') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.hasOwnProperty('org_active')) {
                                            if(element.org_active == false) {
                                                element['org_active'] = false
                                            } else {
                                                element['org_active'] = true
                                            }
                                        } else {
                                            element['org_active'] = false
                                        }
                                        element.company_list.forEach((element1, index1) => {
                                            if(element1.selected) {
                                                this.outer_el = index;
                                                this.inner_el = index1;
                                            }
                                            return;
                                        });
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    var element1 = element.company_list[this.inner_el];
                                    element.company_list.splice(this.inner_el, 1);
                                    element.company_list.splice(0, 0, element1);
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                } else if(this.loggedInUser.user_has == 'company') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.selected) {
                                            this.outer_el = index;
                                        }
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                }
                                this.count_org_comp += response.response.length;
                            }
                            // unlock only after skip/org_comp_count has been updated above
                            this.scroll_flag = response.response.length ? false : true
                        } else {
                            this.scroll_flag = false;
                        }
                    } catch (reason) {
                        this.scroll_flag = false;
                    }
                }
            }
        },
        // hideSuccess() {
        //     this.switch_success = false;
        //     this.setCookie(7);
        //     setTimeout(() => {
        //         axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
        //         window.location.href = global.HELP_URL;
        //     }, 500);
        //     EventBus.$emit('ZindexChangeEnd')
        // },
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
           	document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        async switchNewCompany(comp_id, can_company_switch) {
            if(can_company_switch) {
                try {
                    let params = {
                        company_id: comp_id
                    }
                    let response = await this.switchCompany(params);
                    this.switch_comp_success_message = response.message
                    if(response.token) {
                        this.new_token = response.token;
                        this.$cookie.delete("Token");
                        this.$cookie.delete('Token', {
                            domain: 'digicollect.com'
                        });
                        this.show_hide_comp_switch_dropdown = false
                        this.switch_success = true;
                        this.$emit('SwitchCompanySuccess', response)
                        // setTimeout(() => {
                        //     this.$modal.show('switch-success');
                        //     EventBus.$emit('ZindexChangeStart')
                        // }, 500);
                    }
                }
                catch(err) {
                    console.log(err);
                }
            } else {
                return false;
            }
        },
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        loggedInUserCompanyId() {
            return this.$store.state.store.loggedInUserCompanyId
        }
    } ,
    async mounted(){
        this.getOrganizationAndComp();
        this.api_call_in_progress = true;    
    }
}
</script>
<style scoped>
.header{
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
}
.dropdown-apps {
    width: 240px;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    top: 11px !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.uk-margin-bottom {
    margin-bottom: 16px !important;
}
.uk-grid:after,
.uk-grid:before {
    content: "";
    display: block;
    overflow: hidden;
}
[class*="uk-grid-width"] > * {
    box-sizing: border-box;
    width: 100%;
}
.uk-grid-width-medium-1-3 > * {
     width: 33.333%;
}
.uk-margin-top {
    margin-top: 15px !important;
}
.uk-grid > * {
    -webkit-box-flex: 0;
    flex: none;
    margin: 0;
    width: 100%;
    padding: 5px 10px 7px 17px;
    border-bottom: solid 1px #cce3fc;
    float: left;
    text-align: center;
    text-decoration: none;
    display: flex !important;
    line-height: 22px;
}
.uk-grid > *:last-child {
    border-bottom: solid 0px transparent;
}
.uk-grid > *:hover {
    text-decoration: none;
    background: #cce3fc !important;
}
i.material-icons.md-36 {
    font-size: 28px !important;
    line-height: 36px !important;
    height: 36px !important;
    width: 36px !important;
    padding-bottom: 15px;
    color: #00448b !important;
}
.uk-grid > * > :last-child {
    margin-bottom: 0;
}
@media (min-width: 1220px) {
    .uk-grid > * {
        padding-left: 0px;
    }
}
.uk-text-muted {
    color: #005dae !important;
}
.uk-display-block {
    display: block !important;
}
.logoblock .uk-display-block {
    margin-top: 8px;
    position: relative;
    left: 20px;
}
div.title.h6 {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #00448b;
}
.border-img {
    width: 202px;
    height: 2px;
    object-fit: contain;
    border-radius: 19px;
    padding-left: 10px;
    margin-bottom: 5px;
}
.headerproducts {
    padding: 5px 10px 0px 10px;
}
.viewtxt {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.5px;
    color: #303031;
    padding-right: 6px;
}
.search-group {
    margin-bottom: 0px;
    padding: 10px 10px;
}
.input-search {
    position: relative;
}
.input-search .input-search-close, .input-search .input-search-icon {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 2.573rem;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.input-search .input-search-icon {
    left: 0px;
    font-size: 16px;
    color: #00448b;
    text-align: center;
    pointer-events: none;
    width: 16px;
    height: 16px;
    line-height: 16px;
}
.input-search .input-search-icon+.search-control {
    padding-left: 2.4rem;
}
.search-control:focus + .input-search .input-search-icon {
    color: #00448b !important;
}
.search-control {
    height: 2.573rem;
    -webkit-appearance: none;
    border-color: #005dae;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: -webkit-box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -o-transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -moz-appearance: none;
}
.search-control {
    display: block;
    width: 100%;
    padding: .429rem 1.072rem;
    font-size: 14px;
    line-height: 1.571429;
    color: #303031;
    background-color: #fff;
    background-image: none;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-bottom: 1px solid #cdd2da !important;
    border-radius: 0px;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    overflow: visible;
    margin: 0;
}
.search-control:focus {
    border-color: #005dae !important;
}
button.input-search-close {
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}
.input-search-close.icon {
    font-size: 16px;
    line-height: 16px;
}
.input-search .input-search-close {
    right: 8px;
}
.product-placement{
    position: relative;
    left: 6px;
}
.dropdown-apps {
    width: 220px !important;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    top: 11px !important;
}
.w-220px{
    width: 220px !important;
}
.avatar {
    width: 3rem !important;
    min-width: 3rem !important;
    height: 3rem !important;
}
.right-side-content{
    padding: 10px 25px 10px 10px;
    background: #f0ddb7;
    margin-left:150px;
    border-radius: 11px
}
.gap-1rem{
    gap: 1rem
}
.gap-1p5rem{
    gap: 1.5rem
}
.gap-2rem{
    gap: 2rem
}
.flex-grow-1{
    flex-grow: 1 !important
}
.background{
    background-color: var(--body-screen-bg);
    width: 100% !important;
    padding: 15px 20px;
    user-select: none;
    height: auto !important;
    position: fixed;
    z-index:9999;
    width: calc(100% - 306px);
}
.prd-cont{
    background-color: var(--body-screen-bg) !important;
}
.product-name{
    line-height: 32px
}
.product-logo i{
    color: #fff;
    font-weight: bold;
    text-decoration: none;
    font-size: 17px;
    position: relative;
    top: 2px;
}
.hrms-logo{
    background-color: #00448b;
    border-radius: 5px;
    padding: 5px;
}
.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:2rem;
}
.username{
    letter-spacing: 0.04rem;
}
.switch-company-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.16);
}
.pointer-events-none {
    cursor: no-drop !important;
    pointer-events: none;
}
.pointer{
    cursor: pointer !important;
}
.company-list {
    border: solid 0.2px rgba(128, 132, 149, 0.05);
    background-color: rgba(13, 91, 230, 0.05);
}
.overflow-height {
    max-height: 250px;
    min-height: auto;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.list-dropdown {
  height: 45px;
  padding: 21px 15px 20.9px 13px;
  border-radius: 0px;
  border: solid 0px #ebebeb !important;
  background-color: #ebebeb;
  margin-top: -2px;
}
.open-dropdown{
    border-radius: 5px 5px 0 0;
    border: solid 0.3px #ebebeb;
    height: 50px;
    margin-bottom: -7px;
    margin-top: 5px;
    background-color: #fff;
}
.btn-secondary{
    border-radius: 12px !important;
}
.avatar {
    width: 3rem;
    min-width: 3rem;
    height: 3rem;
    line-height: 4rem;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    font-size: 1.7rem;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    background-color: #fff;
}
.navbar-avatar {
    border-radius: 50% !important;
    font-family: 'Poppins', sans-serif !important;
    width: 30px !important;
    height: 30px !important;
}
.dropdown-width-responsive{
    background-color: #fffcfc;
    border-radius: 10px;
    max-height: 470px;
    margin-left: 15px !important;
    margin-right: 15px !important;
    padding-bottom: 10px;
}
.switch-user-prpfile {
    border-radius: 50%;
    border: 2px solid #ecf1f9;
    width: 54px;
    height: 54px;
}
.green-active-org {
    background-color: #f5f5f5 !important;
    box-shadow: 0 0 6px 0 rgba(178, 191, 235, 0.87);
    border: solid 0px #a3b9ad !important;
    /* background-color: #008b29 !important; */
}
.org-icon-rotate-transition {
    font-size: 24px;
    width: 24px;
    height: 24px;
    line-height: 24px;
}
.org-icon-rotate-transition {
    line-height: 20px;
}
.org-icon-rotate-down.org-icon-rotate-transition {
    transition: all 0.3s;
}
.org-icon-rotate-down {
    transform: rotate(180deg);
}
.hide-on-mob-screen {
    display: block
}
.btn-size{
    width: 110px;
    padding: 0 10px !important;
    margin-left: 280px !important;
    margin-top: -36px !important;
}
.settings-icon {
    top:58px;
    right:29px;
    padding: 4.1px 4px 4.1px 4.3px;
    border-radius: 2px;
}
.setting-align{
    width: 28px;
    /* margin-top: -65px; */
    margin-left: 170px;
    cursor: pointer;
}
.admin-width{
    width: 400px;
    max-height: 520px;
    border-radius: 10px !important;
    background-image: linear-gradient(36deg, #cce5f1 3%, #b8cdf0 53%, #b4bfee 83%, #a8b9ee 90%, #9fb4ef 147%);
    box-shadow: 0 2px 0px 0 rgb(0 0 0 / 10%);
    position: absolute;
    right: -40px;
    left: auto;
    top: 100%;
    margin-top: 8px;
    z-index: 11;
    color: #000000;
    padding: 22px 8px;
}
.main-dropdown {
  border-radius: 5px;
  border: solid 1px #a3b9ad;
  background-color: #ebebeb;
  height: 50px;
  margin-bottom: -8px;
  margin-top: 0px;
}
.border-hide{
    box-shadow: 0 0 6px 0 rgba(178, 191, 235, 0.87);
    border: solid 0px #a3b9ad !important;
}
.main-dropdown.br-t-r-5 {
    border-radius: 5px 5px 0px 0px;
}
.main-dropdown.subcompany-dropdown {
    height: 50px;
}
.background-default{
    background-color: #f4f4f4;
    border: solid 1px #f4f4f4 !important;
}
.show-on-mob-screen {
    display: none;
}
.dropdown-toggle.text-white::after {
    color: #fff !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.dropdown-time {
    top: 11px !important;
}
.products-button{
    background-image: linear-gradient(to bottom, #18bcc4, #18a3aa);
    height: 3.1rem !important;
    line-height: 3.1rem !important;
    border-radius: 5px !important;
    padding: 0px 5px !important;
    width:100px;
    text-transform: capitalize !important;
    max-width: 120px;
    outline: none
}
.isp-active{
    width: 50px;
    border-radius: 4px;
    padding-left: 14px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 5px;
    font-size: 16px;
    background: #25bb83;
    border: solid 1px #cdd2da;
    font-weight: 500;
}
@media screen and (max-width: 450px) {
    .dropdown-width-responsive {
        max-height: 530px;
    }
    .hide-on-mob-screen {
        display: none;
    }
    .admin-width {
        position: fixed;
        top: 50px;
        right: 0;
        left: 0;
        width: 100%;
    }
    .admin-width {
        max-height: 580px;
    }
    .show-on-mob-screen {
        display: block;
    }
}
.mr-maxsm-0{
    margin-right: 0px !important;
}
.release-note{
    background: #e8e9ec;
    border: none !important;
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 40px !important;
}
.display-block-max992{
    display: none;
}
@media screen and (max-width: 992px) {
    .right-side-content{
        margin-left:0px;
    }
    .display-none-max992{
        display: none;
    }
    .display-block-max992{
        display: block;
    }
}
@media screen and (max-width: 900px) {
    .mr-maxsm-0{
        margin-right: 5px !important;
    }
}
.el-popper .popper__arrow, .el-popper .popper__arrow::after {
    position: absolute;
    display: none !important;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
}
.not-selected{
    color: #606465;
}
.back-color{
    background-color: #fff !important;
    padding-top: 10px;
    padding-bottom: 10px;
}
.text-success{
    color: #4CAF50 !important
}
hr{
    border-top: 1px solid #a9ceba !important;
    margin-top: 0px;
    margin-bottom: 2px;
}
input[type=radio] {
    border: 0px;
    width: 18px;
    height: 2em;
    margin-top: 8px;
}
.color-active{
    background-color: #f5f5f5 !important;
}
</style>